module.exports = __webpack_public_path__ + "img/icon-right@3x.f7e93ed1.png";